export default {"src":"/_next/static/image/public/images/flags/flag_1284.7f2d12e135a53c553b32a58cef44a75f.svg","height":16,"width":24};